/**
 * refer-subject-context-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class ReferSubjectContextRequest extends ReplyVerifyingMessage
{
    /** The unique tag for this message type */
    public tag : MessageTag = MessageTag.REQ_REFER_SUBJECT_CONTEXT;
	public static tag : MessageTag = MessageTag.REQ_REFER_SUBJECT_CONTEXT;

    constructor (public objectId : number, public note : string)
    {
        super();
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/context-management/refer-subject-context-request.ts